import { injectGlobal } from 'styled-components';

import {
  colors,
  layers,
  typography
} from '../../theme';

import BrownBoldEOT from '../../fonts/lineto-brown-bold-c.eot';
import BrownBoldTTF from '../../fonts/lineto-brown-bold-c.ttf';
import BrownBoldWOFF from '../../fonts/lineto-brown-bold-c.woff';
import ChiswickHeadlineEOT from '../../fonts/ChiswickHeadline-Extralight-Web.eot';
import ChiswickHeadlineWOFF from '../../fonts/ChiswickHeadline-Extralight-Web.woff';
import ChiswickHeadlineWOFF2 from '../../fonts/ChiswickHeadline-Extralight-Web.woff2';
import UniversLightEOT from '../../fonts/UniversLTStd-Light.eot';
import UniversLightWOFF from '../../fonts/UniversLTStd-Light.woff';
import UniversLightWOFF2 from '../../fonts/UniversLTStd-Light.woff2';
import UniversBoldEOT from '../../fonts/351E07_0_0.eot';
import UniversBoldWOFF from '../../fonts/351E07_0_0.woff';
import UniversBoldWOFF2 from '../../fonts/351E07_0_0.woff2';

injectGlobal`
  @font-face {
    font-family: ${typography.BROWN};
    src: url(${BrownBoldEOT}) format('embedded-opentype'),
         url(${BrownBoldTTF}) format('truetype'),
         url(${BrownBoldWOFF}) format('woff');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: ${typography.CHISWICK};
    src: url(${ChiswickHeadlineEOT}) format('embedded-opentype'),
         url(${ChiswickHeadlineWOFF}) format('woff'),
         url(${ChiswickHeadlineWOFF2}) format('woff2');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: ${typography.UNIVERS};
    src: url(${UniversLightEOT}) format('embedded-opentype'),
         url(${UniversLightWOFF}) format('woff'),
         url(${UniversLightWOFF2}) format('woff2');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: ${typography.UNIVERS};
    src: url(${UniversBoldEOT}) format('embedded-opentype'),
         url(${UniversBoldWOFF}) format('woff'),
         url(${UniversBoldWOFF2}) format('woff2');
    font-weight: bold;
    font-style: normal;
  }

  @keyframes scrollprompt {
    from {
      transform: translate3D(0, -3px, 0);
    }

    to {
      transform: translate3D(0, 3px, 0);
    }
  }

  @keyframes twinkle {
    0% {
      opacity: 0.3;
      transform: scale(0.7);
    }

    5% {
      opacity: 1;
      transform: scale(0.9);
      z-index: ${layers.INTRO__CLOUD_ITEMS__TWINKLING};
    }

    50% {
      opacity: 1;
      transform: scale(0.9);
      z-index: ${layers.INTRO__CLOUD_ITEMS__TWINKLING};
    }

    0% {
      opacity: 0.3;
      transform: scale(0.7);
    }
  }

  *, *:before, *:after {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    box-sizing: border-box;
    outline: none !important;
  }

  html {
    background-color: ${colors.GREY__WHITE};
    font-size: ${typography.VIEWPORT_WIDTH_FONT_SIZE}vw;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    padding: 0;
  }

  body {
    background-color: none;
    margin: 0;
    padding: 0;
    ${typography.BODY}
  }

  button {
    padding: 0;
    margin: 0;
    border: none;
    border-radius: 0;
    font-size: inherit;
    line-height: none;
    background: transparent;
    text-align: left;
    -webkit-appearance: none;
    cursor: pointer;
  }

  @media screen and (min-width: ${typography.MAX_FONT_SIZE/typography.VIEWPORT_WIDTH_FONT_SIZE*100}px) {
    html {
      font-size: ${typography.MAX_FONT_SIZE}px;
    }
  }

  @media screen and (max-width: ${typography.MIN_FONT_SIZE/typography.VIEWPORT_WIDTH_FONT_SIZE*100}px) {
    html {
      font-size: ${typography.MIN_FONT_SIZE}px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/App/global.js